"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classNames = require("classnames");
var RowStatus;
(function (RowStatus) {
    RowStatus["Default"] = "default";
    RowStatus["Muted"] = "muted";
})(RowStatus = exports.RowStatus || (exports.RowStatus = {}));
var Row = function (_a) {
    var _b;
    var isActive = _a.isActive, children = _a.children, status = _a.status, rest = __rest(_a, ["isActive", "children", "status"]);
    var className = classNames((_b = {
            "oui-active": isActive
        },
        _b["oui-table-row-" + status] = true,
        _b));
    var trProps = __assign({}, rest, { className: className });
    return React.createElement("tr", __assign({}, trProps), children);
};
Row.defaultProps = {
    isActive: false,
    status: RowStatus.Default
};
exports.default = Row;
//# sourceMappingURL=TRow.js.map